import React from 'react';

import Snackbar from '@material-ui/core/Snackbar';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';




import FormControl from '@material-ui/core/FormControl';



const LoginDialogs = ({ shouldShowErrorDialog, errorTitle, errorMessage, closeDialogs, shouldShowAccountNeedsVerifiedDialog, sendVerificationEmail, shouldShowforgotPasswordDialog, sendForgotPasswordEmail, updateforgotPassword, shouldShowCompanyListDialog, selectCompany, arrayOfCompanies, selectCompanyRadioButtonChange, selectedCompanyID, shouldShowSnackBar, snackBarMessage }) => {

    return (
        <div>
            <Dialog
                open={shouldShowErrorDialog}
                onClose={closeDialogs}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                >
                 <DialogTitle id="alert-dialog-slide-title">
                     {errorTitle}
                 </DialogTitle>
                 <DialogContent>
                     <DialogContentText id="alert-dialog-slide-description">
                     {errorMessage}
                     </DialogContentText>
                 </DialogContent>
                 <DialogActions>
                     <Button onClick={closeDialogs} color="primary">
                         Ok
                     </Button>
                 </DialogActions>
            </Dialog>


            <Dialog
                open={shouldShowAccountNeedsVerifiedDialog}
                onClose={closeDialogs}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                >
                 <DialogTitle id="alert-dialog-slide-title">
                    Account Needs Verified
                 </DialogTitle>
                 <DialogContent>
                     <DialogContentText id="alert-dialog-slide-description">
                        Your account has not yet been verified.<br/>
                        Would you like for us to resend a verification email ?
                     </DialogContentText>
                 </DialogContent>
                 <DialogActions>
                     <Button onClick={closeDialogs} color="primary">
                        Cancel
                     </Button>
                     <Button onClick={sendVerificationEmail} color="primary" >
                        Resend
                     </Button>
                 </DialogActions>
            </Dialog>


            <Dialog
                open={shouldShowforgotPasswordDialog}
                onClose={closeDialogs}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                >
                 <DialogTitle id="alert-dialog-slide-title">
                    Forgot Password?
                 </DialogTitle>
                 <DialogContent>
                     <DialogContentText id="alert-dialog-slide-description">
                        Enter your email below and we'll send you a link to reset your password.
                     </DialogContentText>
                     <TextField autoFocus margin="dense" id="name" label="Email Address" type="email" fullWidth onChange={updateforgotPassword} />
                 </DialogContent>
                 <DialogActions>
                     <Button onClick={closeDialogs} color="primary">
                        Cancel
                     </Button>
                     <Button onClick={sendForgotPasswordEmail} color="primary" >
                        Send Email
                     </Button>
                 </DialogActions>
            </Dialog>


            <Dialog
                disableBackdropClick
                disableEscapeKeyDown
                maxWidth="xs"
                open={shouldShowCompanyListDialog}
                aria-labelledby="confirmation-dialog-title"
            >
                <DialogTitle id="confirmation-dialog-title">
                    Select A Company
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        We see you are connected with multiple companies, Please select one to sign in with. 
                    </DialogContentText>

                <FormControl component="fieldset" required >

                <RadioGroup
                    ref={node => {
                    this.radioGroup = node;
                    }}
                    aria-label="company-list"
                    name="company-list-name"
                    value={selectedCompanyID}
                    onChange={selectCompanyRadioButtonChange}
                >
                    {arrayOfCompanies.map(({name, companyID, id}) => (
                        <FormControlLabel value={companyID.toString()} key={name} control={<Radio color="primary" />} label={name} />
                    ))}
                </RadioGroup>

                </FormControl>

                </DialogContent>
                <DialogActions>
                {/* <Button onClick={closeDialogs} color="primary">
                    Cancel
                </Button> */}
                <Button onClick={selectCompany} color="primary">
                    Select
                </Button>
                </DialogActions>
            </Dialog>


            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                open={shouldShowSnackBar}
                message={snackBarMessage}
                autoHideDuration={4000}
                onClose={closeDialogs}
            />


        </div>
    );
}

export default LoginDialogs;



// WEBPACK FOOTER //
// ./src/components/Login/LoginDialogs.js